<template>
    <div>
        <div v-if="success" class="alert alert-info">{{ success }}</div>
        <div v-if="error" class="alert alert-danger">Er is iets misgegaan. Controleer a.u.b. uw gegevens.</div>
        <form method="post" class="bg-orange-light p-5 mt-5" @submit.prevent="submit">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-invalid': $v.name.$error }">
                        <label for="name">Uw naam</label>
                        <input type="text" class="form-control" id="name" name="name"
                               v-model.trim.lazy="$v.name.$model"
                               @focus="$v.name.$reset(); clearMsg()">
                        <label v-if="$v.name.$error">
                            <small>
                                {{ $v.name.$error && !$v.name.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-invalid': $v.contact.$error }">
                        <label for="contact">E-mailadres of telefoonnummer</label>
                        <input type="text" class="form-control" id="contact" name="contact"
                               v-model.trim.lazy="$v.contact.$model"
                               @focus="$v.contact.$reset(); clearMsg()">
                        <label v-if="$v.contact.$error">
                            <small>
                                {{ $v.contact.$error && !$v.contact.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group" :class="{ 'has-invalid': $v.question.$error }">
                        <label for="question">Stel uw vraag</label>
                        <textarea class="form-control" id="question" name="question"
                                  v-model.trim.lazy="$v.question.$model"
                                  @focus="$v.question.$reset(); clearMsg()"></textarea>
                        <label>
                            <small v-if="$v.question.$error">
                                {{ $v.question.$error && !$v.question.maxLength ? 'U gebruikt te veel tekens.' : '' }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="col-md-6 offset-6">
                    <button type="submit" class="btn btn-primary btn-block mb-4" :ref="'submitBtn'" :class="{ 'btn-spinner' : processing}">
                        <spinner v-if="processing" :color="'#fdccaf'" class="d-inline-block"></spinner>
                        <template v-else> Verstuur</template>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner.vue';
import {required, maxLength} from 'vuelidate/lib/validators';

export default {
    components: {
        Spinner,
    },
    props: {
        route: String
    },
    data() {
        return {
            name: null,
            contact: null,
            question: null,
            processing: false,
            success: '',
            error: null,
        };
    },
    validations() {
        return {
            name: {
                required,
                maxLength: maxLength(255)
            },
            contact: {
                required,
                maxLength: maxLength(255)

            },
            question: {
                required,
                maxLength: maxLength(10000)
            }
        };
    },
    methods: {
        clearMsg() {
            this.success = '';
            this.error = false;
        },
        submit() {
            this.$refs['submitBtn'].blur()

            this.$v.$touch();

            if (!this.$v.$invalid && !this.processing) {
                this.processing = true;

                this.axios
                    .post(this.route, {
                        'name': this.name,
                        'contact': this.contact,
                        'question': this.question
                    })
                    .then(r => {
                        this.success = r.data.success;
                        this.error = false;

                        this.name = this.contact = this.question = '';
                        this.$v.$reset();
                    })
                    .catch(() => {
                        this.success = '';
                        this.error = true;
                        this.$v.$touch();
                    })
                    .finally(() => {
                        this.processing = false;
                    })
            }
        }
    }
}
</script>

<style scoped>
    .btn {
        display: flex;
        justify-content: center;
    }
    .btn-spinner {
        padding: .75rem;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/components/Contactformulier.vue